#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

query GetTasksForLead($leadId: ID!) {
    lead(id: $leadId) {
        id
        name
        tasks {
            ...CoreEntityTaskFragment
        }
    }
}
